import { render, staticRenderFns } from "./AddAddress.vue?vue&type=template&id=88db51f0&"
import script from "./AddAddress.vue?vue&type=script&lang=ts&"
export * from "./AddAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports